import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import TeamAssistConfiguration from 'models/team_assist_configuration';

export default class TeamAssistConfigurationGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast(dto) {
    this.context.stores.teamAssistConfiguration.set(TeamAssistConfiguration.fromJs(dto));
  }

  onFetchSuccess(dto) {
    this.context.stores.teamAssistConfiguration.resetPending();
    this.context.stores.teamAssistConfiguration.set(TeamAssistConfiguration.fromJs(dto));
  }

  onFetchError(err) {
    handleCommonErrors(this.context, err);
  }
}
